<template>
  <div>
    <el-dialog title="修改" center :visible="true" :close-on-click-modal="false" :close-on-press-escape="false"
      :show-close="true" :before-close="onClose" width="801px">
      <el-form ref="form" :model="form" label-width="160px" size="mini">
        <el-form-item label="标题和正文：">
          <MailTemplate ref="mailTemplate" :languageTemplates="form.template.languageTemplates"
            :readonly="!form.template.isAutoCreated">
          </MailTemplate>
        </el-form-item>

        <el-form-item label="指定收件人：">
          <div style="display: flex; flex-direction: column; gap: 10px;">
            <div>
              <el-radio-group v-model="form.activeReceiversSelectorTabName">
                <el-radio label="byConditions">根据条件</el-radio>
                <el-radio label="byUids">根据uid</el-radio>
                <el-radio label="byTids">根据tid</el-radio>
              </el-radio-group>
            </div>
            <div>
              <div v-if="form.activeReceiversSelectorTabName == 'byConditions'" style="display: flex; flex-direction: column; gap: 10px;">
                <div style="display: flex; align-items: center;">
                  <span>目标分区：</span>
                  <zone-selector placeholder="请选择" enableFullZones @ready="onZoneSelectorReady"
                    @change="onZoneSelectorChange" ref="zoneSelector">
                  </zone-selector>                  
                </div>
                <div style="display: flex; align-items: center;">
                  <span>目标渠道：</span>
                  <channel-selector placeholder="请选择" enableFullChannels @ready="onChannelSelectorReady"
                    @change="onChannelSelectorChange" ref="channelSelector">
                  </channel-selector>                  
                </div>
              </div>
              <div v-else-if="form.activeReceiversSelectorTabName == 'byUids'">
                <el-input type="textarea" rows="5" v-model="form.uidList" placeholder="可放多个uid，每行放1个"
                  style="width: 300px"></el-input>
              </div>
              <div v-else-if="form.activeReceiversSelectorTabName == 'byTids'">
                <el-input type="textarea" rows="5" v-model="form.tidList" placeholder="可放多个tid，每行放1个"
                  style="width: 300px"></el-input>
              </div>              
            </div>
          </div>
        </el-form-item>

        <el-form-item label="附件：">
          <MailAttachmentListBuilder ref="mailAttachmentListBuilder" :attachments="form.attachments">
          </MailAttachmentListBuilder>
        </el-form-item>
        <div v-if="isShowSatrtAndEndAt">
          <el-form-item label="开始定时：" prop="startAt">
            <el-date-picker v-model="form.startAt" type="datetime" :clearable="false" placeholder="选择日期"
              format="yyyy-MM-dd HH:mm" value-format="timestamp">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束定时：" prop="endAt">
            <el-date-picker v-model="form.endAt" type="datetime" :clearable="false" placeholder="选择日期"
              format="yyyy-MM-dd HH:mm" value-format="timestamp">
            </el-date-picker>
          </el-form-item>
        </div>
        <el-form-item label="定时时间类型" prop="cycleType">
          <el-select @change="cycleTypeChange" v-model="form.cycleType" placeholder="请选择">
            <el-option v-for="item in cycleTypeSelector" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="定时时间" prop="cycle">
          <div v-if="form.cycleType == 0">
            <el-date-picker v-model="form.expiredAt" type="datetime" :clearable="false" placeholder="选择日期"
              format="yyyy-MM-dd HH:mm:ss" value-format="timestamp">
            </el-date-picker>
          </div>
          <div v-else-if="form.cycleType == 1">
            <el-select style="width: 130px" v-model="cycleForm.cycle1" placeholder="几点">
              <el-option v-for="item in 24" :key="item + $util.uuid()" :label="`${item - 1}点`" :value="item - 1">
              </el-option>
            </el-select>
            <el-select style="width: 120px; margin-left: 3px" v-model="cycleForm.cycle1_1" placeholder="几分">
              <el-option v-for="item in 60" :key="item + $util.uuid()" :label="`${item - 1}分`" :value="item - 1">
              </el-option>
            </el-select>
          </div>
          <div v-else-if="form.cycleType == 2">
            <el-select style="width: 130px" v-model="cycleForm.cycle2" placeholder="周几">
              <el-option v-for="item in weekDay" :key="item.value + $util.uuid()" :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <el-select style="width: 120px; margin-left: 3px" v-model="cycleForm.cycle2_1" placeholder="几点">
              <el-option v-for="item in 24" :key="item + $util.uuid()" :label="`${item - 1}点`" :value="item - 1">
              </el-option>
            </el-select>
            <el-select style="width: 120px; margin-left: 3px" v-model="cycleForm.cycle2_2" placeholder="几分">
              <el-option v-for="item in 60" :key="item + $util.uuid()" :label="`${item - 1}分`" :value="item - 1">
              </el-option>
            </el-select>
          </div>
          <div v-else-if="form.cycleType == 3">
            <el-select style="width: 130px" v-model="cycleForm.cycle3" placeholder="几号">
              <el-option v-for="item in 31" :key="item + $util.uuid()" :label="`${item}号`" :value="item">
              </el-option>
            </el-select>
            <el-select style="width: 120px; margin-left: 3px" v-model="cycleForm.cycle3_1" placeholder="几点">
              <el-option v-for="item in 24" :key="item + $util.uuid()" :label="`${item - 1}点`" :value="item - 1">
              </el-option>
            </el-select>
            <el-select style="width: 120px; margin-left: 3px" v-model="cycleForm.cycle3_2" placeholder="几分">
              <el-option v-for="item in 60" :key="item + $util.uuid()" :label="`${item - 1}分`" :value="item - 1">
              </el-option>
            </el-select>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onClose()">取消</el-button>
        <el-button type="primary" @click="updateScheduledMails()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const axios = require("axios");

import MailTemplate from "@/pages/mail/components/MailTemplate";
import MailAttachmentListBuilder from "@/pages/mail/components/MailAttachmentListBuilder";
import ZoneSelector from "@/components/ZoneSelector";
import ChannelSelector from "@/components/ChannelSelector";
import MailAttachment from "@/pages/mail/components/MailAttachment";

// 本弹窗名称
const DialogName = "UpdateScheduledMailDialog";

export default {
  data() {
    return {
      form: {
        attachments: [],
        template: {
          languageTemplates: [],
        },
        uidList: "",
        tidList: "",
        activeReceiversSelectorTabName: "byConditions",
        expiredAt: "0",
        cycleType: 0,
        cycle: 0,
        startAt: 0,
        endAt: 0,
      },
      isShowSatrtAndEndAt: false,
      cycleForm: {
        cycle1: 0,
        cycle1_1: 0,
        cycle2: 1,
        cycle2_1: 0,
        cycle2_2: 0,
        cycle3: 1,
        cycle3_1: 0,
        cycle3_2: 0,
      },
      cycleTypeSelector: [
        {
          value: 0,
          label: "单次",
        },
        {
          value: 1,
          label: "每天",
        },
        {
          value: 2,
          label: "每周",
        },
        {
          value: 3,
          label: "每月",
        },
      ],
      weekDay: [
        {
          value: 1,
          label: "周一",
        },
        {
          value: 2,
          label: "周二",
        },
        {
          value: 3,
          label: "周三",
        },
        {
          value: 4,
          label: "周四",
        },
        {
          value: 5,
          label: "周五",
        },
        {
          value: 6,
          label: "周六",
        },
        {
          value: 7,
          label: "周日",
        },
      ],
    };
  },
  components: {
    MailTemplate,
    MailAttachmentListBuilder,
    MailAttachment,
    ChannelSelector,
    ZoneSelector,
  },

  async created() {
    let data = this.$dialogutil.getData(DialogName);

    this.form.id = data.form.id;
    this.form.mailTemplateId = data.form.mailTemplateId;
    this.form.zoneId = data.form.zoneId;
    this.form.channelId = data.form.channelId;
    this.form.isSelectPlayersByConditions =
      data.form.isSelectPlayersByConditions;

    for (let uid of data.form.uidList) {
      this.form.uidList += uid + "\n";
    }

    for (let prop of data.form.props) {
      this.form.attachments.push({
        id: prop.id,
        num: prop.num,
      });
    }
    this.form.startAt = Number(data.form.startAt);
    this.form.endAt = Number(data.form.endAt);
    this.form.cycleType = data.form.cycleType;
    this.form.cycle = data.form.cycle;
    this.form.expiredAt = data.form.expiredAt;
    console.log("form", this.form);
    console.log("data", data.form);
    this.form.template = {
      mailTemplateId: data.form.template.mailTemplateId,
      mailTemplateName: data.form.template.mailTemplateName,
      languageTemplates: data.form.template.mailTemplates,
      isAutoCreated: data.form.template.isAutoCreated,
      activeLanguageTabName: data.form.template.activeLanguageTabName,
    };

    if (this.form.cycleType != 0) {
      this.isShowSatrtAndEndAt = true;
    }

    if (this.form.cycleType == 1) {
      this.cycleForm.cycle1 = parseInt(this.form.cycle / 60);
      this.cycleForm.cycle1_1 = parseInt(this.form.cycle % 60);
    } else if (this.form.cycleType == 2) {
      this.cycleForm.cycle2 = parseInt(this.form.cycle / (60 * 24)) + 1;

      let startDayMinutes = parseInt(this.form.cycle % (60 * 24));
      this.cycleForm.cycle2_1 = parseInt(startDayMinutes / 60);
      this.cycleForm.cycle2_2 = parseInt(startDayMinutes % 60);
    } else if (this.form.cycleType == 3) {
      this.cycleForm.cycle3 = parseInt(this.form.cycle / (60 * 24)) + 1;

      let startDayMinutes = parseInt(this.form.cycle % (60 * 24));
      this.cycleForm.cycle3_1 = parseInt(startDayMinutes / 60);
      this.cycleForm.cycle3_2 = parseInt(startDayMinutes % 60);
    }
  },

  methods: {
    async onChannelSelectorReady() {
      this.$refs.channelSelector.channelId = this.form.channelId;
    },

    async onChannelSelectorChange(newChannelId, oldChannelId) {
      this.form.channelId = newChannelId;
    },

    async onZoneSelectorReady() {
      this.$refs.zoneSelector.zoneId = this.form.zoneId;
    },

    async onZoneSelectorChange(newZoneId, oldZoneId) {
      this.form.zoneId = newZoneId;
    },

    /**
     *
     */
    async updateScheduledMails() {
      try {
        // 取得邮件模板
        let mailTemplate = {};
        {
          let getDataResult = this.$refs.mailTemplate.getData();
          if (getDataResult.errorMessage) {
            this.$message({
              message: getDataResult.errorMessage,
              type: "error",
            });
            return;
          }

          mailTemplate = {
            languageTemplates: getDataResult.data.languageTemplates,
          }
        }

        // 取得附件集合
        let attachments = [];
        {
          let getDataResult = this.$refs.mailAttachmentListBuilder.getData();
          if (getDataResult.errorMessage) {
            this.$message({
              message: getDataResult.errorMessage,
              type: "error",
            });
            return;
          }

          attachments = getDataResult.data.attachments;
        }

        // 弹确认框
        await this.$confirm(`确认修改？`);

        let selectedZoneId = 0;
        let selectedChannelId = 0;
        let cycle = 0;

        // 是否根据条件指定收件人
        let isSelectPlayersByConditions = false;

        // 根据uid指定收件人时所填的uid集合
        let uidList = [];

        // 根据tid指定收件人时所填的tid集合
        let tidList = [];

        if (this.form.activeReceiversSelectorTabName == "byConditions") {
          isSelectPlayersByConditions = true;
        } else if (this.form.activeReceiversSelectorTabName == "byUids") {
          let parseResult = this.parseUidList();
          if (parseResult.err) {
            this.$message({
              message: parseResult.err,
              type: "error",
            });
            return;
          }

          uidList = parseResult.list;
        } else if (this.form.activeReceiversSelectorTabName == "byTids") {
          let parseResult = this.parseTidList();
          if (parseResult.err) {
            this.$message({
              message: parseResult.err,
              type: "error",
            });
            return;
          }

          tidList = parseResult.list;
        }

        if (isSelectPlayersByConditions) {
          selectedZoneId = this.form.zoneId;
          selectedChannelId = this.form.channelId;
        }

        let templates = [];
        for (let temp of this.form.template.languageTemplates) {
          templates.push(temp);
        }

        if (this.form.cycleType == 0) {
          if (Number(this.form.expiredAt) <= new Date().getTime()) {
            this.$alert("定时时间必须在当前时间之后", "提示", {
              confirmButtonText: "确定",
            });
            return;
          }
        } else if (this.form.cycleType == 1) {
          let cycle1 = Number(this.cycleForm.cycle1);
          let cycle1_1 = Number(this.cycleForm.cycle1_1);
          cycle = cycle1 * 60 + cycle1_1;
        } else if (this.form.cycleType == 2) {
          let cycle2 = Number(this.cycleForm.cycle2);
          let cycle2_1 = Number(this.cycleForm.cycle2_1);
          let cycle2_2 = Number(this.cycleForm.cycle2_2);

          cycle = (cycle2 - 1) * 24 * 60 + cycle2_1 * 60 + cycle2_2;
        } else if (this.form.cycleType == 3) {
          let cycle3 = Number(this.cycleForm.cycle3);
          let cycle3_1 = Number(this.cycleForm.cycle3_1);
          let cycle3_2 = Number(this.cycleForm.cycle3_2);

          cycle = (cycle3 - 1) * 24 * 60 + cycle3_1 * 60 + cycle3_2;
        }

        let startAt = new Date(this.form.startAt).setSeconds(0, 0);
        let endAt = new Date(this.form.endAt).setSeconds(59, 999);

        let body = {
          id: this.form.id,
          mailTemplateId: this.form.mailTemplateId,
          zoneId: selectedZoneId,
          channelId: selectedChannelId,
          isSelectPlayersByConditions: isSelectPlayersByConditions,
          uidList: uidList,
          tidList: tidList,
          props: JSON.stringify(attachments),
          expiredAt: this.form.expiredAt,
          template: {
            mailTemplateId: this.form.template.mailTemplateId,
            mailTemplateName: this.form.template.mailTemplateName,
            mailTemplates: templates,
          },
          cycleType: this.form.cycleType,
          cycle: cycle,
          startAt: String(startAt),
          endAt: String(endAt),
        };

        let resData = (
          await axios.post(
            `${this.$util.getBackendApiBase()}/v1/admin/updateScheduledMail`,
            body,
            {
              headers: {
                token: this.$bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message({
            message: resData.message,
            type: "error",
          });
          return;
        }
        this.$message({
          message: "修改成功",
          type: "success",
        });

        // 关闭当前对话框
        this.onClose(null);
      } catch (e) { }
    },

    /**
     * 解析uid集合
     *
     * @returns {list: [], err: "xxxx"}
     */
    parseUidList() {
      let list = [];

      let uidListStr = this.form.uidList.trim();
      if (uidListStr.length > 0) {
        let arr = uidListStr.split(/\s+/);
        for (let e of arr) {
          let uid = Number(e);
          if (isNaN(uid) || uid != parseInt(uid)) {
            return {
              list: [],
              err: "玩家ID格式错误",
            };
          }

          if (uid <= 0) {
            return {
              list: [],
              err: "玩家ID必须是正整数",
            };
          }

          list.push(uid);
        }
      }

      if (list.length == 0) {
        return {
          list: [],
          err: "请输入玩家ID",
        };
      }

      return {
        list: list,
      };
    },

    /**
     * 解析tid集合
     *
     * @returns {list: [], err: "xxxx"}
     */
    parseTidList() {
      let list = [];

      let tidListStr = this.form.tidList.trim();
      if (tidListStr.length > 0) {
        let arr = tidListStr.split(/\s+/);
        for (let e of arr) {
          let tid = e.trim();
          if (tid.length == 0) {
            continue;
          }

          list.push(tid);
        }
      }

      if (list.length == 0) {
        return {
          list: [],
          err: "请输入tid",
        };
      }

      return {
        list: list,
      };
    },

    async cycleTypeChange(e) {
      if (e == 0) {
        this.isShowSatrtAndEndAt = false;
      } else {
        this.isShowSatrtAndEndAt = true;
      }
    },
    onClose(done) {
      // 关闭当前对话框
      this.$dialogutil.close(DialogName);
    },
  },
};
</script>